import axios from 'axios';
import common from './Common';
import { authTokenKey } from 'constants/localStorage';

export const setAuthToken = (token) => {
  axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
};

export const deleteAuthToken = () => {
  delete axios.defaults.headers.common['Authorization'];
};
if (localStorage.getItem(authTokenKey)) {
  axios.defaults.headers.common['Authorization'] =
    'Bearer ' + localStorage.getItem(authTokenKey);
}

axios.interceptors.request.use(
  (config) => config,
  (error) => Promise.reject(error),
);
// axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem(authTokenKey);

class Request {
  constructor() {
    //Init cancelToken. Note: Must create cancel token for each request
    this.cancelToken = axios.CancelToken;
    this.source = this.cancelToken.source();
  }

  get(url, params) {
    let { urlProcess, allParams } = common.getURL(url, params);

    let dataSubmit = {
      params: allParams,
    };

    if (params?.responseType == 'blob') {
      dataSubmit['responseType'] = 'blob';
    }

    return axios
      .get(urlProcess, dataSubmit)
      .then((response) => {
        return response.data;
      })
      .catch(() => {});
  }

  post(url, params, config) {
    const { urlProcess, allParams } = common.getURL(url, params);
    const formPost = common.createFrom(allParams);

    return axios
      .post(urlProcess, formPost, config)
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        return Object.assign({}, error.response.data, {
          error_code: error.response.status,
        });
      });
  }

  put(url, params, config) {
    const { urlProcess, allParams } = common.getURL(url, params);
    const formPost = common.createFrom(allParams);

    return axios
      .put(urlProcess, formPost, config)
      .then((response) => {
        return response.data;
      })
      .catch(() => {});
  }

  delete(url, params, config = {}) {
    const { urlProcess, allParams } = common.getURL(url, params);

    return axios
      .delete(urlProcess, { params: allParams, ...config })
      .then((response) => {
        return response.data;
      })
      .catch(() => {});
  }

  //Cancel request by token request
  actionCancel() {
    this.source.cancel('Operation canceled by the user.');
  }
}

export default new Request();
